import { updateStates } from '@/utils/reducer';
import {
  GET_APPLICATION,
  GET_APPLICATION_SUCCESS,
  GET_APPLICATIONS_SUCCESS,
  GET_VARIANT_GROUPS_SUCCESS,
} from '@/store/types/application';

const initState = {
  isLoading: true,
  config: {},
  list: [],
  variantGroups: [],
};

const reducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_APPLICATION:
      return updateStates(state, { isLoading: true });
    case GET_APPLICATION_SUCCESS:
      return updateStates(state, { config: payload, isLoading: false });
    case GET_APPLICATIONS_SUCCESS:
      return updateStates(state, { list: payload });
    case GET_VARIANT_GROUPS_SUCCESS:
      return updateStates(state, { variantGroups: payload });

    default:
      return state;
  }
};

export default reducer;
